import Joi from 'joi';

export interface CreateDataArchivalForm {
  examYear: string;
  archivalLevelSelect: boolean;
  approver: any;
  remarks: string;
}

export const createDataArchivalSchema = () =>
  Joi.object({
    examYear: Joi.string().required().messages({
      'any.required': 'Exam year is not allowed to be empty.',
    }),
    archivalLevelSelect: Joi.boolean().valid(true).required().messages({
      'any.only': 'Must select at least one level from one group.',
      'any.required': 'Must select at least one level from one group.',
    }),
    approver: Joi.any().required().messages({
      'any.required': 'Please select Approver.',
    }),
    remarks: Joi.string().trim().min(1).required().messages({
      'any.required': 'Please enter reason.',
      'string.empty': 'Please enter reason.',
    }),
  });
